import React           from "react";
import PropTypes       from 'prop-types';
import Translations    from '../../../utils/Translations';
import { generateKey } from '../../../utils/CommonUtils';

const AboutMePlate = (props) => {


    const personIcon = props?.isMale ? '-icon-fact-male-body' : '-icon-fact-female-body';
    const titleText  = props?.isCouple 
        ? Translations.get('actor_profile.about_me-plate-title.couple') 
        : Translations.get('actor_profile.about_me-plate-title.solo');
    
    const circleItems = props?.aboutCircleItems && Object.entries(props.aboutCircleItems).map(([iconClass, title], index) => {
        const positionClass = index === 0 ? '-top-left' : (index === 1 ? '-top-right' : '-bottom-right');
        return (
            <div 
                key={generateKey('about-circle-item', index)}
                className={`about-circle__fact ${positionClass}`}
            >
                <span className={`about-circle__fact__icon icon-actor ${iconClass}`}/>
                <div className="about-circle__fact__caption">
                    {title}
                </div>
            </div>
        );
    });
    
    return (
        <div className="about-me-my-profile-plate">
            <h3 className="content-box__body__headline">{titleText}</h3>

            <div className="about__circle">
                <span className={`about-circle__person icon-actor ${personIcon}`}/>
                {circleItems}
            </div>
        </div>
    );
};

AboutMePlate.propTypes = {
    aboutCircleItems: PropTypes.object,
    isCouple:         PropTypes.bool,
    isMale:           PropTypes.bool
};

export default AboutMePlate;